import type { ReactNode } from 'react';
import { memo } from 'react';
import { Heading } from '@library';
import styles from './ProductAttributeTitle.module.css';

const ProductAttributeTitle = ({ children }: { children: ReactNode }) => (
    <Heading h6 medium uppercase>
        <div className={styles.productAttributeTitle}>{children}</div>
    </Heading>
);

export default memo(ProductAttributeTitle);
